import React from 'react';
import { GLOBAL_TABLET_MENU_LINKS } from '../../../constants/common/GlobalTabletMenuLinks';

/**
 * Menu
 */
class Menu extends React.Component {

  constructor(props) {
    super(props);
    this.handleCloseMenuClick = this.handleCloseMenuClick.bind(this);
  }

  handleCloseMenuClick() {
    $('#menu_page').hide();
  }

  render() {
    const Nodes = (
      GLOBAL_TABLET_MENU_LINKS.map((linkInfo, parentIndex) => {
        return (
          <div key={parentIndex} className="menu_page_content" id="menu_page_content">
            {linkInfo.links.map((link, index) => {
              return (
                <div key={index} className="menu_page_item" id="menu_page_item">
                  <a href={link.url} className="tab-title">
                    {link.name}
                  </a>
                </div>
              );
            })}
          </div>
        );
      })
    );

    return (
      <div id="menu_page" className="menu_page" onClick={e => this.handleCloseMenuClick(e)}>
        <div className="menu_page_bg" />
        <div id="menu_btn_close" className="menu_btn_close_area">
          {Nodes}
        </div>
      </div>
    );
  }
}

export default Menu;
